<section id="project1" class="projects" data-scroll-nav="0">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-7 col-md-7 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div
							class="d-flex flex-column justify-content-center h-100 service-content"
						>
							<div>
								<h1 class="heading text-uppercase">detail master</h1>
								<div class="points">
									<p>
										Detail Master, a specialist in interior design and fit-out,
										delivers timeless elegance and precision in every bespoke
										space.
									</p>
									<p>
										<a
											class="text-decoration-underline"
											href="https://www.detailmastergroup.com/"
											target="_blank"
											>detailmastergroup.com</a
										>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 col-md-5 col-sm-6">
						<div
							class="d-flex flex-column justify-content-center align-items-sm-end"
						>
							<div class="list-block">
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									<a href="{{ Url }}/project-details/detail-master#brandings"
										>Branding</a
									>
								</h3>
								<!-- <h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="1500"
									data-aos-delay="150"
								>
									<a href="{{ Url }}/project-details/detailmaster#animations"
										>Animations</a
									>
								</h3> -->
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="2000"
									data-aos-delay="200"
								>
									<a href="{{ Url }}/project-details/detail-master#ui-ux"
										>UI/UX Design</a
									>
								</h3>
								<!-- <h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="2500"
									data-aos-delay="250"
								>
									<a href="{{ Url }}/project-details/detailmaster#development"
										>Development</a
									>
								</h3> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section data-scroll-nav="1" class="pb-0">
	<div class="container-fluid p-0">
		<div class="row">
			<div
				class="col-md-12 p-0"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<img
					src="{{
						baseUrl
					}}/images/projects/detail-master/detail-master-min.jpg"
					alt="Branding agency in Dubai"
					width=""
					height=""
					loading="lazy"
				/>
			</div>
		</div>
	</div>
</section>
<section class="section bgColor about-project" data-scroll-nav="2">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="content">
					<p class="">
						Detail Master, a leader in bespoke interior design and fit-out
						solutions, sought to elevate its digital presence to reflect its
						25-year legacy of global craftsmanship. Pixtar partnered with Detail
						Master to redefine its branding and UI/UX, ensuring alignment with
						its core values of precision, timeless elegance, and client-centric
						innovation.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bgColor branding" id="brandings" data-scroll-nav="3">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="heading">Branding</h1>
							<p class="">
								Pixtar developed a visual language that reflects Detail Master’s
								commitment to precision and global sophistication.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div
				class="col-md-12 p-0"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="imglist mb-3">
					<img
						src="{{
							baseUrl
						}}/images/projects/detail-master\small_stationery_mockup_2-min.jpg"
						alt="best web design company in dubai"
						width=""
						height=""
						loading="lazy"
					/>
				</div>
			</div>
			<div
				class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<img
							src="{{
								baseUrl
							}}/images/projects/detail-master/promotion-min.jpg"
							alt="web designing agency dubai"
							width=""
							height=""
							loading="lazy"
						/>
					</div>
					<div
						class="col-xl-6 col-lg-6 col-md-6 ps-md-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="list">
							<img
								src="{{
									baseUrl
								}}/images/projects/detail-master/detail-master-logo-min.jpg"
								alt="Top branding agency in Dubai"
								width=""
								height=""
								loading="lazy"
							/>
							<img
								src="{{ baseUrl }}/images/projects/detail-master/home-02.jpg"
								alt="website development company dubai"
								width=""
								height=""
								loading="lazy"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="bgColor typography" data-scroll-nav="5">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="typography">
					<img
						src="{{ baseUrl }}/images/projects/detail-master/group-288-min.png"
						alt="typography"
						width=""
						height=""
						loading="lazy"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					/>
					<p
						class="text-dark"
						data-aos="fade-up"
						data-aos-duration="2500"
						data-aos-delay="100"
					>
						Designed a minimalist yet impactful logo, balancing sharp geometric
						lines (symbolizing precision) with warm metallic accents (reflecting
						timeless elegance). Created an engaging story based on "mastering
						details" to showcase the company's decades of turning visions into
						everlasting spaces
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="ui-ux pt-5" id="ui-ux" data-scroll-nav="8">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="heading mb-2">UI/UX Design</h1>
							<p class="">
								The website was engineered to prioritize functionality while
								immersing users in Detail Master’s world of meticulous design.
								Built with HTML5 and Bootstrap for seamless adaptability across
								devices, ensuring flawless project galleries and service
								displays.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div
						class="col-lg-9 mx-lg-auto"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<img
							class="w-100 h-auto desktopimg"
							id="myImage"
							width="320"
							height="176"
							src="{{
								baseUrl
							}}/images/projects/detail-master/image0001-min.png"
							alt="Project Image"
						/>

						<!-- <img src="{{baseUrl}}/images/projects/dnour/dnour-desktop.png" alt="website developers in dubai" width="" height="" class="desktopimg"> -->

						<!-- <img src="{{baseUrl}}/images/projects/dnour/dnour-laptop.png" alt="web development company dubai" width="" height=""> -->
						<!-- <img
							class="w-100 h-auto desktopimg"
							id="myImage"
							width="320"
							height="176"
							src="{{ baseUrl }}/images/projects/miniaar/Group-583.png"
							alt="Project Image"
						/> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section
	class="next bg-black pb-0"
	data-aos="fade-up"
	data-aos-duration="2000"
	data-aos-delay="100"
>
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="next-block">
					<div class="in-line">
						<!-- next project link here -->
						<a
							href="{{ Url }}/project-details/crystalcargolink"
							class="text-white font-bold border-radius-25"
						>
							<img
								src="{{
									baseUrl
								}}/images/projects/crystalcargo/branding-image-03.jpg"
								alt="Best Web Designers in Dubai"
								width="280"
								height="280"
								loading="lazy"
							/>
							<h1 class="heading text-white">NEXT PROJECT</h1>
						</a>
						<!-- (click)="$event.preventDefault()  -->
					</div>
				</div>
			</div>
		</div>
		<div class="line"></div>
	</div>
</section>
